import type { BatteryProposalDto } from "~/api/dto/battery-proposal.dto"

import {
  isBatteryContractPath,
  isBatteryFinancingStatusPath,
} from "./setup/setup-steps"

/** An explicit server denial keeps readable proposals out of editing flows. */
export const isBatteryProposalReadOnly = (
  proposal: BatteryProposalDto,
): boolean => proposal.viewerCanUpdate === false

/**
 * Paths a read-only actor keeps: the proposal itself plus the two status
 * drawers, whose own actions stay server-gated. Every other Battery path is an
 * editing surface, so the shell sends a read-only actor back to the proposal.
 */
export const isBatteryReadOnlyPath = (pathname: string): boolean =>
  isBatteryContractPath(pathname) || isBatteryFinancingStatusPath(pathname)
